import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiReadsCountButtonComponent } from './fi-reads-count-button.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatDialogModule } from '@angular/material/dialog';
import { FiUserInteractionsDialogComponent } from '@fi-shared/fi-news-feed-shared/fi-news-feed-buttons/fi-reads-count-button/fi-reads-user-list-data-dialog/fi-reads-user-list-data-dialog.component';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { MatTabsModule } from '@angular/material/tabs';
import { FiUsersListRelatedToObjectTypeModule } from '@fi-shared/fi-users-list-related-to-object-type/fi-users-list-related-to-object-type.module';

@NgModule({
    declarations: [FiReadsCountButtonComponent, FiUserInteractionsDialogComponent],
    imports: [
        CommonModule,
        MatIconModule,
        MatCardModule,
        MatButtonModule,
        FiProfileIconModule,
        FiAppTextSharedModule,
        MatDialogModule,
        FiLoadingModule,
        MatTabsModule,
        FiUsersListRelatedToObjectTypeModule,
    ],
    exports: [FiReadsCountButtonComponent, FiUserInteractionsDialogComponent],
})
export class FiReadsCountButtonModule {}
